import i18n from "i18n";

const prepTypeMapping = {
  BAS: i18n.t("prep.type.bas"),
  REQ: i18n.t("prep.type.req"),
  SALE: i18n.t("prep.type.sale"),
  ADJ: i18n.t("prep.type.adj"),
  BRE: i18n.t("prep.type.bre"),
  LOSS: i18n.t("prep.type.loss"),
  AUD: i18n.t("prep.type.aud"),
};

export default prepTypeMapping;
